import { Skeleton as BoneyardSkeleton, type SkeletonProps } from "boneyard-js/react";
import { usePrefersReducedMotion } from "@/hooks/use-prefers-reduced-motion";

export function BoneScreen({ animate, select = "viewport", ...props }: SkeletonProps) {
  const reduceMotion = usePrefersReducedMotion();
  return (
    <BoneyardSkeleton
      {...props}
      animate={animate ?? (reduceMotion ? false : "shimmer")}
      select={select}
    />
  );
}
